import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { RedirectService } from '../shared/redirect.service';
import { environment } from '../../../environments/environment';
import { timer } from 'rxjs/observable/timer';

@Directive({
    selector: '[appSessionTimeout]',
})
export class SessionTimeoutDirective {
    @Output() alertInactivity: EventEmitter<any> = new EventEmitter();
    private suscribeSession!: Subscription;
    private suscribeAlert!: Subscription;
    private timerSession: Observable<number>;
    private timerAlert: Observable<number>;
    private readonly pagesWithoutInactivity;
    private readonly timeoutSession: number;
    private readonly alertTimeoutSession: number;

    constructor(
        private readonly router: Router,
        private readonly redirectService: RedirectService
    ) {
        this.timeoutSession = environment.timeoutSession;
        this.alertTimeoutSession = environment.alertTimeoutSession;
        this.timerAlert = this.setTimer(this.alertTimeoutSession);
        this.timerSession = this.setTimer(this.timeoutSession);
        this.pagesWithoutInactivity = environment.pagesWithoutInactivity;
        this.setSubscribe();
    }

    resetTimer(): void {
        this.suscribeSession.unsubscribe();
        this.suscribeAlert.unsubscribe();
        this.timerAlert = this.setTimer(this.alertTimeoutSession);
        this.timerSession = this.setTimer(this.timeoutSession);
        this.setSubscribe();
    }

    counterTime(): void {
        const url = this.router.url;
        if (this.pagesWithoutInactivity.indexOf(url.split('?')[0]) <= -1) {
            console.log(
                `Han pasado ${this.timeoutSession} segundos de inactividad, se procede a cerrar sesión.`
            );
            return this.redirectService.redirectToUrl(
                environment.launcherEndpoint
            );
        } else {
            return this.resetTimer();
        }
    }

    private setSubscribe(): void {
        const timeElapsed = this.defineTimeElapsed();
        this.suscribeSession = this.timerSession.subscribe({
            next: () => {
                this.counterTime();
            },
        });
        if (this.alertTimeoutSession < this.timeoutSession) {
            this.suscribeAlert = this.timerAlert.subscribe({
                next: () => {
                    if (
                        !this.pagesWithoutInactivity.includes(
                            this.router.url.split('?')[0]
                        )
                    ) {
                        this.alertInactivity.emit(timeElapsed);
                    }
                },
            });
        }
    }

    defineTimeElapsed(): number {
        return this.timeoutSession - this.alertTimeoutSession;
    }

    private setTimer(time: number): Observable<number> {
        return timer(time * 1000);
    }

    @HostListener('keypress', ['$event'])
    @HostListener('DOMMouseScroll', ['$event'])
    @HostListener('touchmove', ['$event'])
    @HostListener('mousedown', ['$event'])
    @HostListener('mousemove', ['$event'])
    @HostListener('window:modalSelection', ['$event'])
    onEvent(event: any): void {
        this.resetTimer();
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/session-timeout.directive.ts